import ProductUserActionContentMap from '../constants/ContentfulFallback/ProductUserActionContentMap';
import { sendNewRelicError } from './NewRelicUtils';
import { CONTENTFUL_ERROR } from '../views/OneClick/constants';
import { setApolloState } from '../lib/ApolloSchema/apolloUtils';
import { PlanSelectionVariations } from '../constants/interfaces';
import { CSP_UPSELL_FALLBACK, PLAN_SELECTION_FALLBACK } from '../constants/ContentfulFallback/PlanSelectionCases';
/**
 * Util to return content if API is successful, return fallback content if API fails
 * @param params
 * @returns content
 */
export var getContentfulData = function getContentfulData(params) {
  var content = params.content,
    orderManagementAction = params.orderManagementAction,
    cartCheckoutAction = params.cartCheckoutAction,
    planSelectionVariation = params.planSelectionVariation,
    externalId = params.externalId,
    itemData = params.itemData,
    action = params.action,
    country = params.country,
    queryName = params.queryName;
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!content || !(content !== null && content !== void 0 && content.data)) {
    sendNewRelicError(CONTENTFUL_ERROR, {
      errors: "externalId: ".concat(externalId, ", productType: ").concat(itemData[0].productType, ", action: ").concat(action, ", country: ").concat(country, ", message: ").concat(content === null || content === void 0 ? void 0 : content.error, ", queryName: ").concat(queryName)
    });
    setApolloState({
      uiData: {
        isLoaded: true
      }
    });
  } else {
    var data = content.data;
    if (orderManagementAction && data.commerce1ClickOrderManagementLocaleCollection) return {
      content: data.commerce1ClickOrderManagementLocaleCollection.items[0]
    };
    if (cartCheckoutAction && data.commerce1ClickCartCheckoutLocaleCollection) return {
      content: data.commerce1ClickCartCheckoutLocaleCollection.items[0]
    };
    if (planSelectionVariation && data.commerce1ClickPlanSelectionLocaleCollection) return {
      content: data.commerce1ClickPlanSelectionLocaleCollection.items[0]
    };
  }
  return {
    content: planSelectionVariation ? getFallbackPlanSelectionContent(planSelectionVariation) : getFallbackContent(action, itemData[0].productType)
  };
};
export var getFallbackPlanSelectionContent = function getFallbackPlanSelectionContent(planSelectionVariation) {
  switch (planSelectionVariation) {
    case PlanSelectionVariations.PLAN_SELECTION:
      return PLAN_SELECTION_FALLBACK;
    case PlanSelectionVariations.CSP_UPSELL:
      return CSP_UPSELL_FALLBACK;
    default:
      return {};
  }
};

/**
 * Returns fallback content based on user action and product type
 * @param action User Action
 * @param productType CS/CSP
 * @returns content
 */
export var getFallbackContent = function getFallbackContent(action, productType) {
  var _ProductUserActionCon;
  var fallback = (_ProductUserActionCon = ProductUserActionContentMap[action]) === null || _ProductUserActionCon === void 0 ? void 0 : _ProductUserActionCon[productType];
  return fallback || {};
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/utils/ContentfulUtil.js
// module id = 4176
// module chunks = 11